import PropertyItemEditModal from './PropertyItemEditModal';

export default PropertyItemEditModal;
